// assets/pmn-globo-contrast-v2.js
(() => {
  const BG_LABEL = "Couleur de fond";
  const TEXT_LABELS = ["Couleur d'écriture", "Couleur d’écriture"];

  // Quand le fond est BLANC, on masque l'option "Blanc" pour la couleur d'écriture
  const HIDE_WHITE_TEXT_WHEN_BG_WHITE = true;

  const norm = (s) =>
    String(s || "")
      .trim()
      .toLowerCase()
      .replaceAll("’", "'")
      .replace(/\s+/g, " ");

  const isTextLabel = (s) => TEXT_LABELS.map(norm).includes(norm(s));
  const isBgLabel = (s) => norm(s) === norm(BG_LABEL);
  const labelKey = (s) =>
    norm(s)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s*[:*]\s*$/, "");

  const LABEL_REPLACEMENTS = [
    ["Police d'écriture", "Choisissez une police d'écriture"],
    ["Police d’écriture", "Choisissez une police d'écriture"],
    ["Couleur de fond", "Choisissez une couleur de fond"],
    ["Couleur d'écriture", "Choisissez une couleur d'écriture"],
    ["Couleur d’écriture", "Choisissez une couleur d'écriture"],
    ["Quantité", "Choisissez une quantité"],
    ["Forme", "Choisissez une forme"],
  ];

  function replacementForLabel(raw) {
    const key = labelKey(raw);
    const match = LABEL_REPLACEMENTS.find(([from]) => labelKey(from) === key);
    return match ? match[1] : null;
  }

  function setDisplayedLabel(el, label) {
    if (!el || norm(el.textContent) === norm(label)) return;

    const textNode = Array.from(el.childNodes).find(
      (node) => node.nodeType === Node.TEXT_NODE && norm(node.textContent)
    );

    if (textNode) {
      textNode.textContent = label;
      return;
    }

    el.textContent = label;
  }

  function relabelProductOptionLabels() {
    const selector = [
      ".name-option[data-name]",
      ".globo-variant-selector .name-option",
      ".product-form__input > label.form__label",
      ".product-option.shape-picker > label.form__label",
    ].join(",");

    document.querySelectorAll(selector).forEach((el) => {
      const source = el.getAttribute("data-name") || el.getAttribute("data-option-name") || el.textContent;
      const label = replacementForLabel(source);
      if (label) setDisplayedLabel(el, label);
    });
  }

  // ---------- color helpers (data-* seulement)
  function parseColor(str) {
    if (!str) return null;
    const s = String(str).trim().toLowerCase();

    if (s.startsWith("#")) {
      let hex = s.slice(1);
      if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
      if (hex.length !== 6) return null;
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      if ([r, g, b].some(Number.isNaN)) return null;
      return { r, g, b };
    }

    const m = s.match(/rgba?\(\s*(\d+)\s*[,\s]\s*(\d+)\s*[,\s]\s*(\d+)/);
    if (m) return { r: +m[1], g: +m[2], b: +m[3] };

    return null;
  }

  const isNearBlack = (c) => {
    const p = parseColor(c);
    return p ? p.r < 25 && p.g < 25 && p.b < 25 : false;
  };
  const isNearWhite = (c) => {
    const p = parseColor(c);
    return p ? p.r > 230 && p.g > 230 && p.b > 230 : false;
  };

  const wordIsBlack = (v) => /(^|\b)(noir|black)(\b|$)/i.test(String(v || ""));
  const wordIsWhite = (v) => /(^|\b)(blanc|white)(\b|$)/i.test(String(v || ""));

  // ---------- roots
  function getProductRoot() {
    return (
      document.querySelector("variant-selects") ||
      document.querySelector("variant-radios") ||
      document.querySelector('form[action^="/cart/add"]') ||
      document
    );
  }

  // returns { kind: 'radio', radios: [...], selectedEl } or { kind: 'select', select, selectedEl } or null
  function findVariantControlByOptionName(root, matcher /* fn(name)->bool */) {
    const radios = Array.from(root.querySelectorAll('input[type="radio"][data-option-name]')).filter((r) =>
      matcher(r.dataset.optionName)
    );
    if (radios.length) {
      const checked = radios.find((r) => r.checked) || null;
      return { kind: "radio", radios, selectedEl: checked };
    }

    const selects = Array.from(root.querySelectorAll("select"));
    for (const sel of selects) {
      const opts = Array.from(sel.options);
      const has = opts.some((o) => o?.dataset?.optionName && matcher(o.dataset.optionName));
      if (has) {
        const selectedOpt = sel.options[sel.selectedIndex] || null;
        return { kind: "select", select: sel, selectedEl: selectedOpt };
      }
    }
    return null;
  }

  function selectColorInTextControl(ctrl, want /* 'white'|'black' */) {
    if (!ctrl) return false;

    const wantsWhite = want === "white";

    if (ctrl.kind === "radio") {
      const byMeta = ctrl.radios.find((r) =>
        wantsWhite ? isNearWhite(r.dataset?.textColor) : isNearBlack(r.dataset?.textColor)
      );
      const byWord = ctrl.radios.find((r) => (wantsWhite ? wordIsWhite(r.value) : wordIsBlack(r.value)));

      const target = byMeta || byWord;
      if (target) {
        target.click();
        return true;
      }
      return false;
    }

    if (ctrl.kind === "select") {
      const sel = ctrl.select;
      const opts = Array.from(sel.options);

      const byMeta = opts.find((o) =>
        wantsWhite ? isNearWhite(o.dataset?.textColor) : isNearBlack(o.dataset?.textColor)
      );
      const byWord = opts.find((o) =>
        wantsWhite
          ? wordIsWhite(o.value) || wordIsWhite(o.textContent)
          : wordIsBlack(o.value) || wordIsBlack(o.textContent)
      );

      const target = byMeta || byWord;
      if (target) {
        sel.value = target.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
        sel.dispatchEvent(new Event("input", { bubbles: true }));
        return true;
      }
      return false;
    }

    return false;
  }

  // ---------- Globo UI helpers
  function findGroupByLabelText(labelText) {
    const allLabels = Array.from(
      document.querySelectorAll("legend, label, .form__label, [class*='label'], [class*='title']")
    );

    const hit = allLabels.find((el) => norm(el.textContent).includes(norm(labelText)));
    if (!hit) return null;

    return (
      hit.closest("fieldset") ||
      hit.closest(".product-form__input") ||
      hit.closest("[class*='swatch']") ||
      hit.parentElement
    );
  }

  function ensureHiddenStyle() {
    if (document.getElementById("pmn-hide-style")) return;
    const style = document.createElement("style");
    style.id = "pmn-hide-style";
    style.textContent = `.pmn-hidden{display:none!important;}`;
    document.head.appendChild(style);
  }

  function getVal(el) {
    const direct =
      el.getAttribute?.("data-value") ||
      el.getAttribute?.("data-option-value") ||
      el.getAttribute?.("aria-label") ||
      el.getAttribute?.("title") ||
      el.dataset?.value;

    if (direct) return direct;

    const inp = el.querySelector?.('input[type="radio"]');
    if (inp?.value) return inp.value;

    return el.textContent;
  }

  // IMPORTANT: pas de fallback "computedStyle" ici (ça t'a confondu le violet avec le blanc)
  function findTargetInGroup(groupEl, want /* 'white'|'black' */) {
    if (!groupEl) return null;

    const clickables = Array.from(
      groupEl.querySelectorAll("button, [role='option'], label, a, input[type='radio']")
    );

    const isWanted = (el) => {
      const v = getVal(el);
      if (want === "white") return wordIsWhite(v);
      if (want === "black") return wordIsBlack(v);
      return false;
    };

    const prefer = (el) => (el.matches("input,button,label,[role='option']") ? 0 : 1);

    const sorted = clickables
      .filter(isWanted)
      .sort((a, b) => prefer(a) - prefer(b));

    return sorted[0] || null;
  }

  function clickValueInGroup(groupEl, want /* 'white'|'black' */) {
    const target = findTargetInGroup(groupEl, want);
    if (!target) return false;

    if (target.matches?.('input[type="radio"]')) {
      target.click();
      return true;
    }

    const radio = target.querySelector?.('input[type="radio"]');
    if (radio) radio.click();
    else target.click?.();

    return true;
  }

  // ---------- bg detection
  function bgIsBlackNow(root) {
    const bgCtrl = findVariantControlByOptionName(root, isBgLabel);
    if (bgCtrl?.selectedEl) {
      const el = bgCtrl.selectedEl;
      const bc = el.dataset?.bgColor;
      const v = el.value || el.textContent || "";
      return isNearBlack(bc) || wordIsBlack(v);
    }

    const grp = findGroupByLabelText(BG_LABEL);
    const selected = grp?.querySelector?.(
      "[aria-checked='true'], [aria-selected='true'], .active, .selected, .is-selected, input[type='radio']:checked"
    );
    const v = selected
      ? selected.getAttribute("aria-label") || selected.getAttribute("title") || selected.textContent
      : "";
    return wordIsBlack(v);
  }

  function bgIsWhiteNow(root) {
    const bgCtrl = findVariantControlByOptionName(root, isBgLabel);
    if (bgCtrl?.selectedEl) {
      const el = bgCtrl.selectedEl;
      const bc = el.dataset?.bgColor;
      const v = el.value || el.textContent || "";
      return isNearWhite(bc) || wordIsWhite(v);
    }

    const grp = findGroupByLabelText(BG_LABEL);
    const selected = grp?.querySelector?.(
      "[aria-checked='true'], [aria-selected='true'], .active, .selected, .is-selected, input[type='radio']:checked"
    );
    const v = selected
      ? selected.getAttribute("aria-label") || selected.getAttribute("title") || selected.textContent
      : "";
    return wordIsWhite(v);
  }

  // ---------- “wrappers” (pour masquer / ordonner)
  function wrapperFor(el) {
    // Wrapper "item" sans remonter trop haut (important pour ne pas casser Globo)
    return (
      el.closest?.("li") ||
      el.closest?.(".globo-swatch-item") ||
      el.closest?.(".globo-color-swatch-item") ||
      el.closest?.("[class*='swatch-item']") ||
      el.closest?.("label") ||
      el.closest?.("button") ||
      el
    );
  }

  // Masquage du blanc quand fond blanc (sans toucher l'ordre)
  function syncTextWhiteVisibility(root) {
    if (!HIDE_WHITE_TEXT_WHEN_BG_WHITE) return;

    ensureHiddenStyle();

    const textGroup = findGroupByLabelText(TEXT_LABELS[0]);
    if (!textGroup) return;

    const whiteTarget = findTargetInGroup(textGroup, "white");
    if (!whiteTarget) return;

    const wrap = wrapperFor(whiteTarget);
    if (!wrap) return;

    const shouldHide = bgIsWhiteNow(root);
    wrap.classList.toggle("pmn-hidden", shouldHide);
  }

  // Ordre du picker texte :
  // - Fond NOIR -> Blanc en 1er (puis Noir), le reste inchangé
  // - Fond BLANC -> on NE réordonne pas (et Blanc est masqué)
  function applyTextOrder(root) {
    const textGroup = findGroupByLabelText(TEXT_LABELS[0]);
    if (!textGroup) return;

    const whiteClickable = findTargetInGroup(textGroup, "white");
    const blackClickable = findTargetInGroup(textGroup, "black");
    if (!whiteClickable || !blackClickable) return;

    const whiteItem = wrapperFor(whiteClickable);
    const blackItem = wrapperFor(blackClickable);
    if (!whiteItem || !blackItem) return;

    const container = whiteItem.parentElement;
    if (!container || container !== blackItem.parentElement) return;

    // Si pas flex/grid, "order" ne sert à rien => on évite tout bricolage DOM
    const display = getComputedStyle(container).display || "";
    const canOrder = display.includes("flex") || display.includes("grid");

    // reset si on avait déjà joué avec order
    const children = Array.from(container.children).filter((n) => n.nodeType === 1);
    const resetOrders = () => {
      for (const el of children) el.style.order = "";
      container.dataset.pmnOrdered = "";
    };

    const bgBlack = bgIsBlackNow(root);

    // Fond noir : la bulle Noir est masquée, la bulle Blanc prend sa place (comme sur les packs)
    ensureHiddenStyle();
    blackItem.classList.toggle("pmn-hidden", bgBlack);

    if (!canOrder) {
      resetOrders();
      return;
    }

    if (!bgBlack) {
      // fond blanc (ou autre) : pas de réordonnancement, et on reset pour ne pas garder un ordre "collé"
      resetOrders();
      return;
    }

    // fond noir : Blanc doit être 1er, Noir 2e, le reste après
    container.dataset.pmnOrdered = "1";
    for (const el of children) el.style.order = "2";
    whiteItem.style.order = "0";
    blackItem.style.order = "1";
  }

  // ---------- rule state (auto switch conditionnel)
  let pendingBg = false;
  let oldTextWasBlack = false;
  let oldTextWasWhite = false;

  // Guard to avoid loops when we click programmatically
  let internalUpdate = false;

  function computeOldTextFlags(root) {
    const textCtrl = findVariantControlByOptionName(root, isTextLabel);
    if (textCtrl?.selectedEl) {
      const el = textCtrl.selectedEl;
      const tc = el.dataset?.textColor;
      const v = el.value || el.textContent || "";
      return {
        wasBlack: isNearBlack(tc) || wordIsBlack(v),
        wasWhite: isNearWhite(tc) || wordIsWhite(v),
      };
    }

    const grp = findGroupByLabelText(TEXT_LABELS[0]);
    const selected = grp?.querySelector?.(
      "[aria-checked='true'], [aria-selected='true'], .active, .selected, .is-selected, input[type='radio']:checked"
    );
    const v = selected
      ? selected.getAttribute("aria-label") || selected.getAttribute("title") || selected.textContent
      : "";
    return { wasBlack: wordIsBlack(v), wasWhite: wordIsWhite(v) };
  }

  function syncUi(root) {
    relabelProductOptionLabels();
    // 1) Masquer / afficher le blanc selon fond blanc
    syncTextWhiteVisibility(root);
    // 2) Fond noir -> blanc 1er (CSS order)
    applyTextOrder(root);
  }

  function applyRule() {
    const root = getProductRoot();
    if (!pendingBg) return;
    pendingBg = false;

    // Toujours : mettre à jour UI (masquage + ordre)
    syncUi(root);

    // Auto-switch conditionnel
    let want = null;

    // Fond NOIR + ancien texte NOIR => texte BLANC
    if (oldTextWasBlack && bgIsBlackNow(root)) want = "white";

    // Fond BLANC + ancien texte BLANC => texte NOIR
    if (oldTextWasWhite && bgIsWhiteNow(root)) want = "black";

    if (!want) return;

    internalUpdate = true;

    // 1) Click Globo UI for visual selection
    clickValueInGroup(findGroupByLabelText(TEXT_LABELS[0]), want);

    // 2) Also force underlying control if present (variant correctness)
    const textCtrl = findVariantControlByOptionName(root, isTextLabel);
    selectColorInTextControl(textCtrl, want);

    // 3) Retry once (some themes rerender) + resync UI
    setTimeout(() => {
      clickValueInGroup(findGroupByLabelText(TEXT_LABELS[0]), want);
      syncUi(getProductRoot());
      internalUpdate = false;
    }, 80);
  }

  function onBgInteraction() {
    const root = getProductRoot();
    const flags = computeOldTextFlags(root);
    oldTextWasBlack = flags.wasBlack;
    oldTextWasWhite = flags.wasWhite;
    pendingBg = true;

    // Globo/Dawn can update async, so we try twice
    setTimeout(applyRule, 50);
    setTimeout(applyRule, 200);
  }

  // Listen: changes from underlying controls (if present)
  document.addEventListener(
    "change",
    (e) => {
      if (internalUpdate) return;
      const t = e.target;
      const optName = t?.dataset?.optionName;
      if (optName && isBgLabel(optName)) onBgInteraction();
    },
    true
  );

  // Also listen: clicks inside the background group (Globo UI)
  document.addEventListener(
    "click",
    (e) => {
      if (internalUpdate) return;
      const bgGroup = findGroupByLabelText(BG_LABEL);
      if (bgGroup && e.target && bgGroup.contains(e.target)) {
        onBgInteraction();
      }
    },
    true
  );

  // Init
  const init = () => {
    const root = getProductRoot();
    setTimeout(() => syncUi(root), 50);
    setTimeout(() => syncUi(getProductRoot()), 200);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Filet de sécurité : si Globo rerender, on resynchronise (sans bouger le DOM)
  const mo = new MutationObserver(() => {
    if (internalUpdate) return;
    clearTimeout(mo._t);
    mo._t = setTimeout(() => syncUi(getProductRoot()), 80);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
